import { SECONDS_PER_MINUTE, MINUTES_PER_HOUR } from '../constants/durations';

function calculateSecondsInHours(hours = 1) {
  return SECONDS_PER_MINUTE * MINUTES_PER_HOUR * hours;
}

export {
  calculateSecondsInHours,
};
